import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";

export const AppDndProvider = ({ children, isMobile }) => {
  const backend = isMobile ? TouchBackend : HTML5Backend;
  const options = isMobile ? { enableMouseEvents: true } : {};

  return (
    <DndProvider backend={backend} options={options}>
      {children}
    </DndProvider>
  );
};
